





import {Component, Prop, Vue} from 'vue-property-decorator';
import {ActiveInject} from "@/support/reactive"
import moment from 'moment';
import 'moment/locale/en-gb';
import 'moment/locale/fi';
import 'moment/locale/lv';

function shortRelative (date: moment.Moment | Date | string) {
    if (typeof date !== 'object') {
        date = new Date(date);
    }

    let seconds = Math.floor((new Date() - date) / 1000);
    let intervalType;

    let interval = Math.floor(seconds / 31536000);
    if (interval >= 1) {
        intervalType = 'y';
    } else {
        interval = Math.floor(seconds / 2592000);
        if (interval >= 1) {
            intervalType = 'mo';
        } else {
            interval = Math.floor(seconds / 86400);
            if (interval >= 1) {
                intervalType = 'd';
            } else {
                interval = Math.floor(seconds / 3600);
                if (interval >= 1) {
                    intervalType = "h";
                } else {
                    interval = Math.floor(seconds / 60);
                    if (interval >= 1) {
                        intervalType = "m";
                    } else {
                        interval = seconds;
                        intervalType = "s";
                    }
                }
            }
        }
    }

    return interval + intervalType;
}

/**
 * @status stable
 * @published 2.0.0
 * @changelog 2.0.0 Published.
 * @changelog 3.2.0 Support specificity of `day`.
 * @changelog 5.9.0 Prevent translation.
 */
@Component
export default class JdsTimestamp extends Vue {
    @ActiveInject({from: 'jds.locale', default: 'en-us'}) locale!: string;

    /**
     * Any moment-compatible value, but ideally an ISO8601-compatible string.
     */
    @Prop() time!: string;
    @Prop({default: false, type: Boolean}) relative!: boolean;
    @Prop({default: false, type: Boolean}) shortRelative!: boolean;
    /**
     * Determines the smallest unit we show. It may not be relevant for a timestamp to show
     *  a hours and minutes if it's only referring to a specific day, for example.
     */
    @Prop({default: 'minute'}) specificity!: 'minute' | 'day';

    get timestamp() {
        const m = moment(this.time);
        m.locale(this.locale);
        return m;
    }

    get tooltip() {
        switch (this.specificity) {
            case "day":
                return this.timestamp.format('ll');
            default:
                return this.timestamp.format('llll');
        }
    }

    get display() {
        if (this.shortRelative) {
            return shortRelative(this.timestamp)
        }

        if (this.relative) {
            return this.timestamp.fromNow();
        }

        if (this.timestamp.isAfter(moment())) {
            // return "04/09/2100 8:30 PM" if in the future and is within 1 day...
            if (this.timestamp.isSame(moment(), 'day') && this.specificity !== 'day') return this.timestamp.format('L LT');
            // return "04/09/2100" if in the future beyond one day
            return this.timestamp.format('L');
        }

        // return "8:30 PM" if today...
        if (this.timestamp.isSame(moment(), 'day') && this.specificity !== 'day') return this.timestamp.format('LT');

        // return "04/09/2100"
        return this.timestamp.format('L');
    }


}
